export default "__VITE_ASSET__Czjugh$C__"